import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

/**
 * @summary 对 component Dialog 进行包装，使其支持自定义样式
 */

import { forwardRef } from "react";
interface Props {
	title?: string | React.ReactNode;
	subTitle?: string | React.ReactNode;
	className?: string;
	overlay?: React.ReactNode;
	children: React.ReactNode;
	visible: boolean;
	onClose: () => void;
}

const CustomDialog = forwardRef<React.ElementRef<typeof Dialog>, Props>((props, ref) => {
	return (
		<Dialog open={props.visible} onOpenChange={(open) => !open && props.onClose()}>
			<DialogContent ref={ref} overlay={props.overlay} className={props.className}>
				<DialogHeader>
					<DialogTitle>{props.title}</DialogTitle>
					<DialogDescription>{props.subTitle}</DialogDescription>
				</DialogHeader>

				{props.children}
			</DialogContent>
		</Dialog>
	);
});

CustomDialog.displayName = "CustomDialog";

export default CustomDialog;
